import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useCallback } from 'react';

/**
 * Custom hook to manage a boolean flag state.
 *
 * @param {boolean} initialState - the initial state of the flag
 * @return {[boolean, {enable: () => void, disable: () => void}]} an array containing the
 * flag state and an object with enable and disable functions
 */
function useFlag(initialState) {
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    flag = _useState2[0],
    setFlag = _useState2[1];
  return [flag, {
    enable: useCallback(function () {
      return setFlag(true);
    }, []),
    disable: useCallback(function () {
      return setFlag(false);
    }, [])
  }];
}

export { useFlag };
//# sourceMappingURL=useFlag.js.map
